"use client";

import { useEffect } from "react";
import { sendGTMEvent } from "@next/third-parties/google";
import { PolicyContentBase } from "./PolicyContentBase";

export const TermsPolicyContent: React.FC<{ initialPolicy?: any }> = ({ initialPolicy }) => {
  useEffect(() => {
    // --- GOOGLE ANALYTICS: Event Tracking ---
    try {
      sendGTMEvent({
        event: "page_view_manual",
        page_name: "terms_and_conditions",
      });
    } catch (error) {
      console.debug("GTM event error:", error);
    }
  }, []);

  return (
    <PolicyContentBase
      apiEndpoint="/api/terms-and-conditions"
      defaultTitle="Terms & Conditions"
      initialPolicy={initialPolicy}
    />
  );
};
